// Polyfill to make 'global' available in the browser environment
(window as any).global = window;
